/**
 * How a field shows focus.
 *
 * stears.co does not recolour an input's border when it is focused: its input class
 * pins the border at #4B5563 through `focus:border-border-100` and pins the text
 * colour across the focused and unfocused states, signalling focus with the
 * background instead (`focus:bg-…`). The blue #85BEFF border this app used to draw
 * on focus is not how Stears inputs behave, so it has been removed.
 *
 * Focus is still shown, because an input that gives no feedback when focused fails
 * WCAG 2.4.7 and the specification commits to AA (section 11.4). The indicator is a
 * background lift from `background-input` to `background-skeleton`, both existing
 * Stears tokens, which is the same mechanism the site uses.
 *
 * The error border stays red: that is a different signal and the design system
 * specifies it.
 */
export const FIELD_BORDER = '#4B5563'
export const FIELD_BORDER_ERROR = '#F05042'
export const FIELD_BACKGROUND = '#1F2937'
export const FIELD_BACKGROUND_FOCUSED = '#2D3036'

export interface FieldSurface {
  borderColor: string
  backgroundColor: string
}

/** The border and fill for a field in a given state. */
export function fieldSurface(state: { focused?: boolean; error?: boolean }): FieldSurface {
  return {
    borderColor: state.error ? FIELD_BORDER_ERROR : FIELD_BORDER,
    backgroundColor: state.focused ? FIELD_BACKGROUND_FOCUSED : FIELD_BACKGROUND,
  }
}
